function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.792 0h14.36c.438 0 .792.354.792.792 0 .406-.305.74-.7.786l-.091.005H.791C.354 1.583 0 1.23 0 .792 0 .386.306.052.7.005L.791 0h14.36H.793z",
  transform: "translate(-34 -450) translate(15 416) translate(3) translate(16 34) translate(1.528 6.412)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.8,
  d: "M12.058 8.661L10.91 7.57c-.129-.123-.337-.123-.466 0-.13.123-.13.321 0 .444l1.382 1.316c.13.123.338.123.467 0l3.499-3.33c.129-.123.129-.322 0-.444-.129-.123-.337-.123-.466 0L12.058 8.66z",
  transform: "translate(-34 -450) translate(15 416) translate(3) translate(16 34) translate(1.528 6.412)"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.384 13.03H3.816c-.187 0-.366-.073-.498-.206-.133-.132-.207-.31-.207-.498V5.09c0-.389.316-.704.705-.704h11.368c.39 0 .705.315.705.704V9.5c0 .437.354.792.791.792.438 0 .792-.355.792-.792V5.09c0-1.263-1.024-2.287-2.288-2.287H3.816c-1.264 0-2.288 1.024-2.288 2.287v7.236c0 .607.241 1.189.67 1.618.43.43 1.011.67 1.618.67h4.568c.437 0 .791-.354.791-.792 0-.437-.354-.791-.791-.791z",
  transform: "translate(-34 -450) translate(15 416) translate(3) translate(16 34)"
}))))));

function SvgPaymentCardDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCardDefault);
export default __webpack_public_path__ + "static/media/payment-card-default.daf87d0d.svg";
export { ForwardRef as ReactComponent };